@use '../../../design-tokens/border-radius/border-radius' as *;
@use '../../../design-tokens/typography/typography' as *;

@layer design-system {
  .mainLabel {
    @include typography-v2-body-sm;
    color: var(--text-default);
    flex: 1;
    margin: 0 8px 0 0;

    &.isActive {
      margin: 0 8px;
      padding-left: 8px;
    }
  }

  .item {
    position: relative;
    @include border-radius-r1;
    display: flex;
    align-items: center;
    padding: 8px;
    margin: 8px 0 0 8px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 8px;
    }

    &:hover,
    &:focus-visible {
      background-color: var(--surface-hover);
    }

    &.isCondensed {
      padding: 6px 8px;
    }

    &.isFocused {
      background-color: var(--surface-hover);
    }

    &.isActive {
      margin: 8px 0 0;
      background-color: var(--surface-active);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 4px;
        height: 36px;
        width: 4px;
        background-color: var(--border-primary);
      }
    }

    &.isDisabled {
      pointer-events: none;
      cursor: default;

      svg {
        fill: var(--icon-disabled);
      }

      .mainLabel {
        color: var(--text-disabled);
      }
    }
  }

  .leadingIconContainer {
    width: 20px;
    height: 20px;
    margin: 0 8px 0 0;
    display: flex;
    align-items: center;

    &.isActive {
      margin: 0 0 0 8px;
    }
  }

  .trailingIconContainer {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
  }

  .supportiveText {
    @include typography-v2-body-xs;
    color: var(--text-soft);
    text-align: right;
    margin-left: 8px;
  }

  .loadingContainer {
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .separator {
    height: 1px;
    background-color: var(--border-soft);
    border: none;
  }
}
